import React from "react"

export default class Loader extends React.Component {

    render() {
        return (
            <div className="loader"/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/SmallLoader.js